import firebase from 'firebase'
import 'firebase/firestore'
// a1lci65L9fsS5RD6iWl6
//ccc

const yyschool = "/schools/3rjIXFglv9A2d4u15wTV/"

const REAL_APP = true
const EYESH_APP = false
const COOKING_APP = false

const config = {
 
  // apiKey: "AIzaSyAUUz2RYnfvWBrYBeuad1Ul5uN0NZBSCx4",
  // authDomain: "khuvsgul-8efed.firebaseapp.com",
  // projectId: "khuvsgul-8efed",
  // storageBucket: "khuvsgul-8efed.appspot.com",
  // messagingSenderId: "543801818833",
  // appId: "1:543801818833:web:30dadc849c0a74fdcf4ff0"
  
  // apiKey: "AIzaSyDUoVVpLKmXIoFLtToD64dZzeCHFyf7MtI",
  // authDomain: "digitalschool-3f1e9.firebaseapp.com",
  // projectId: "digitalschool-3f1e9",
  // storageBucket: "digitalschool-3f1e9.appspot.com",
  // messagingSenderId: "667372416860",
  // appId: "1:667372416860:web:036c4483d3da2d923b9b99",
  // measurementId: "G-GD56WG73B9"

  //digitalsurguuli@gmail.com
  // apiKey: "AIzaSyBUsdngoliI5cloSlIoqpqRMpOJzyEtJ6M",
  // authDomain: "digitalschoolstorage.firebaseapp.com",
  // projectId: "digitalschoolstorage",
  // storageBucket: "digitalschoolstorage.appspot.com",
  // messagingSenderId: "370821067954",
  // appId: "1:370821067954:web:b1ee09e85f969615ffc5ab"
  

  // apiKey: "AIzaSyAWLhZ9uLJUSPhCcbX4xQVFi-M0jYs36fk",
  // authDomain: "bulgan-schools-89dad.firebaseapp.com",
  // projectId: "bulgan-schools-89dad",
  // storageBucket: "bulgan-schools-89dad.appspot.com",
  // messagingSenderId: "864993947444",
  // appId: "1:864993947444:web:859a600d874e2d285b3f61"


  // apiKey: "AIzaSyAcXVQYRCNoiHVU4ef54KBMSDjLfbUWYEY",
  // authDomain: "bulgan-4f806.firebaseapp.com",
  // projectId: "bulgan-4f806",
  // storageBucket: "bulgan-4f806.appspot.com",
  // messagingSenderId: "209963170332",
  // appId: "1:209963170332:web:dc74b42aad9253f4ac3dd9"
 
 
  // apiKey: "AIzaSyB2WCIQnWKFlQsWIGClgSwo2S1KPxDGSnI",
  // authDomain: "dundgovi-4d576.firebaseapp.com",
  // projectId: "dundgovi-4d576",
  // storageBucket: "dundgovi-4d576.appspot.com",
  // messagingSenderId: "734714351351",
  // appId: "1:734714351351:web:95c1deed8685d5e863cdf2"

 
 
  // apiKey: "AIzaSyDcriWZpZ_4Tj3YVfyvUKOdHpnCqiV579g",
  // authDomain: "eyesh800-ae733.firebaseapp.com",
  // projectId: "eyesh800-ae733",
  // storageBucket: "eyesh800-ae733.appspot.com",
  // messagingSenderId: "637398427967",
  // appId: "1:637398427967:web:d5cf9168e0245b9b2bcb8a"
 
  // apiKey: "AIzaSyBX4eku4KgfqZVsSIZfemODUDXNFXb8Tik",
  // authDomain: "mongeni-1bfe2.firebaseapp.com",
  // projectId: "mongeni-1bfe2",
  // storageBucket: "mongeni-1bfe2.appspot.com",
  // messagingSenderId: "279997219698",
  // appId: "1:279997219698:web:2c9eab3021f1ff0bfe93eb"

  //zavkhan aimag

  // apiKey: "AIzaSyAGO9AwziM4_rh07vq3BprRmlZlLlc5dN8",
  // authDomain: "zavkhanaimag-eyesh.firebaseapp.com",
  // projectId: "zavkhanaimag-eyesh",
  // storageBucket: "zavkhanaimag-eyesh.appspot.com",
  // messagingSenderId: "948005963190",
  // appId: "1:948005963190:web:63aea98dbde526eb5aad17"


  // apiKey: "AIzaSyDryFs4FXGuDSmsSQ5-OQujrxcAYqsGfAI",
  // authDomain: "uvsaimag-eyesh.firebaseapp.com",
  // projectId: "uvsaimag-eyesh",
  // storageBucket: "uvsaimag-eyesh.appspot.com",
  // messagingSenderId: "527505746482",
  // appId: "1:527505746482:web:f4c41c4083ed163c48aa2b",
  // measurementId: "G-ZZEV2RY52V"

  // apiKey: "AIzaSyAMe5yviC8Tj71QkshxUgkrMs7d2Bbjmf8",
  // authDomain: "emos-53478.firebaseapp.com",
  // projectId: "emos-53478",
  // storageBucket: "emos-53478.appspot.com",
  // messagingSenderId: "695404454822",
  // appId: "1:695404454822:web:109d65630812b534dba567"

  //smos

  apiKey: "AIzaSyBCNIlfRIuqbMicsgkoDssQ8F0MkopyXD8",
  authDomain: "surguuli1-web.firebaseapp.com",
  projectId: "surguuli1-web",
  storageBucket: "surguuli1-web.appspot.com",
  messagingSenderId: "836781678490",
  appId: "1:836781678490:web:cfc683f458bb35b49d2423",
  measurementId: "G-WLC0FV7TJM"

  

};

const eyesh800 = {
  apiKey: "AIzaSyDcriWZpZ_4Tj3YVfyvUKOdHpnCqiV579g",
  authDomain: "eyesh800-ae733.eyesh800-ae733firebaseapp.com",
  projectId: "eyesh800-ae733",
  storageBucket: "eyesh800-ae733.appspot.com",
  messagingSenderId: "637398427967",
  appId: "1:637398427967:web:d5cf9168e0245b9b2bcb8a"


  // apiKey: "AIzaSyAGO9AwziM4_rh07vq3BprRmlZlLlc5dN8",
  // authDomain: "zavkhanaimag-eyesh.firebaseapp.com",
  // projectId: "zavkhanaimag-eyesh",
  // storageBucket: "zavkhanaimag-eyesh.appspot.com",
  // messagingSenderId: "948005963190",
  // appId: "1:948005963190:web:63aea98dbde526eb5aad17"

}

const fbeyesh800 = firebase.initializeApp(eyesh800, "secondary");
export const dbeyesh800 = fbeyesh800.firestore()

const digitalschoolstorage ={

  apiKey: "AIzaSyBUsdngoliI5cloSlIoqpqRMpOJzyEtJ6M",
  authDomain: "digitalschoolstorage.firebaseapp.com",
  projectId: "digitalschoolstorage",
  storageBucket: "digitalschoolstorage.appspot.com",
  messagingSenderId: "370821067954",
  appId: "1:370821067954:web:b1ee09e85f969615ffc5ab"
}

console.log(digitalschoolstorage)
const fbDSStorage = firebase.initializeApp(digitalschoolstorage, "digitalschoolstorage");
export const dbDSStorage = fbDSStorage.firestore()



firebase.initializeApp(config)

// const dbold = firebase
//   .initializeApp({
//     apiKey: "AIzaSyDryFs4FXGuDSmsSQ5-OQujrxcAYqsGfAI",
//     authDomain: "uvsaimag-eyesh.firebaseapp.com",  
//     projectId: "uvsaimag-eyesh",
//     storageBucket: "uvsaimag-eyesh.appspot.com",
//     messagingSenderId: "527505746482",
//     appId: "1:527505746482:web:f4c41c4083ed163c48aa2b",
//     measurementId: "G-ZZEV2RY52V"
//   },
//     "uvsaimag-eyesh"
//   )
//   .firestore();


// firebase utils
const firestore = firebase.firestore
const db = firebase.firestore()
const auth = firebase.auth()
const currentUser = auth.currentUser

var googleProvider = new firebase.auth.GoogleAuthProvider();
googleProvider.addScope('email');

const storage = firebase.storage;
const storageRef = firebase.storage().ref();
export {
  db,
  auth,
  currentUser,
  googleProvider,
  storage,
  storageRef,
  firestore,
  yyschool,
  COOKING_APP,
  EYESH_APP,
  REAL_APP,
}